<template>
  <div>
    <div class="ffftitle">专业就业排名</div>
    <br />
    <div style="display: flex; align-items: center">
      <el-button style="margin-left: 10px" @click="$router.back()" type="text">
        &lt;&lt;返回
      </el-button>
      <el-pagination
        background
        layout="total, prev, pager, next"
        :total="total"
        :page-size="pageSize"
        :current-page="current"
        @current-change="handleCurrentChange"
        style="display: inline-block"
      >
      </el-pagination>
    </div>
    <el-table
      height="calc(100vh - 80px - 17px - 32px)"
      v-loading="loading"
      :data="currentData"
      style=""
    >
      <el-table-column prop="xxmc" label="学校名称"> </el-table-column>
      <el-table-column prop="year" label="年份"> </el-table-column>
      <el-table-column prop="xscc" label="学历层次"> </el-table-column>
      <el-table-column prop="zymc" label="专业名称"> </el-table-column>
      <el-table-column prop="byrs" label="毕业人数"> </el-table-column>
      <el-table-column prop="jyrs" label="就业人数"> </el-table-column>
      <el-table-column prop="jyl" label="就业率" width="180">
        <template slot-scope="scope">
          {{ (parseFloat(scope.row.jyl) * 100).toString() | filterJyl }}%
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>


<script>
import ForecastService from "../../api/forecast";
export default {
  data() {
    return {
      params: {
        school_name: "",
        major_name: "",
      },
      loading: true,
      tableData: [],
      current: 1,
      total: 0,
      pageSize: 100,
    };
  },
  computed: {
    currentData() {
      const current = this.current - 1;
      return this.tableData.slice(
        current * this.pageSize,
        (current + 1) * this.pageSize
      );
    },
  },
  filters: {
    filterJyl(value) {
      if (value.indexOf(".") > -1) {
        if (value.length > 5) {
          value = value.slice(0, 5);
        }
      }
      return value;
    },
  },
  async mounted() {
    this.params.school_name = this.$route.query.school_name || undefined;
    this.params.major_name = this.$route.query.major_name || undefined;
    // false
    const res = await ForecastService.ProRank({
      ...this.params,
    });
    this.loading = false;
    this.total = res[0].length;
    this.tableData = res[0];
  },
  methods: {
    handleCurrentChange(nextPage) {
      this.current = nextPage;
    },
  },
};
</script>


<style lang="less" scoped>
.ffftitle {
  width: 100%;
  height: 80px;
  background-image: url(../../assets/img/query06.png);
  background-position: center center;
  background-repeat: no-repeat;
  background-size: auto;
  background-position: 0 -100px;
  text-align: center;
  line-height: 80px;
  font-size: 32px;
  color: black;
  letter-spacing: 20px;
  opacity: 0.8;
}
</style>